import { PAGE_SIDE_PADDING } from '../../../constants';
import { useExpandedMode } from '../configuration-canvas/panels-reserve-space/useExpandedMode';
import { HORIZONTAL_PADDING } from './consts';

export const useGetSidePadding = () => {
  const { isExpandedMode } = useExpandedMode();
  const withNewPadding = isExpandedMode;
  return withNewPadding ? PAGE_SIDE_PADDING : HORIZONTAL_PADDING;
};
